export default __webpack_public_path__ + "static/media/ethereal3.51f0215f.jpeg";